class ProductReviewSlider extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        const swiperEl = this.querySelector('.section-product-review-slider-swiper');
        if (!swiperEl) return;

        this.swiper = new Swiper(swiperEl, {
            slidesPerView: 1.3,
            spaceBetween: 12,
            navigation: {
                nextEl: this.querySelector('.section-review-slider-next'),
                prevEl: this.querySelector('.section-review-slider-prev'),
            },
            breakpoints: {
                480: {
                    slidesPerView: 1.6
                },
                600: {
                    slidesPerView: 2.1
                },
                768: {
                    slidesPerView: 2.5
                }, 
                990: {
                    slidesPerView: 3.2
                },
                1024: {
                    slidesPerView: 3.7,
                    spaceBetween: 24
                },
                1440: {
                    slidesPerView: 3.7,
                    spaceBetween: 24
                }
            }
        });
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}

if (!customElements.get('product-review-slider')) {
    customElements.define('product-review-slider', ProductReviewSlider);
}